import { render, staticRenderFns } from "./CheckboxOption.vue?vue&type=template&id=6640d680&scoped=true"
import script from "./CheckboxOption.vue?vue&type=script&lang=js"
export * from "./CheckboxOption.vue?vue&type=script&lang=js"
import style0 from "./CheckboxOption.vue?vue&type=style&index=0&id=6640d680&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6640d680",
  null
  
)

export default component.exports